// src/locales/si/supplier.js
export const supplier = {
  // Page title and descriptions
  manageSuppliers: 'සැපයුම්කරුවන් කළමනාකරණය කරන්න',
  viewAndManageSuppliers: 'ඔබගේ සැපයුම්කරුවන් බලන්න සහ කළමනාකරණය කරන්න',

  // Statistics
  totalSuppliers: 'සම්පූර්ණ සැපයුම්කරුවන්',
  activeSuppliers: 'සක්‍රීය සැපයුම්කරුවන්',
  inactiveSuppliers: 'අක්‍රීය සැපයුම්කරුවන්',

  // Actions
  createNewSupplier: 'නව සැපයුම්කරු සෑදීම',
  createFirstSupplier: 'ඔබගේ පළමු සැපයුම්කරු සෑදීම',
  editSupplier: 'සැපයුම්කරු සංස්කරණය කරන්න',
  deleteSupplier: 'සැපයුම්කරු මකන්න',
  createSupplier: 'සැපයුම්කරු සෑදීම',
  updateSupplier: 'සැපයුම්කරු යාවත්කාලීන කරන්න',

  // Fields
  supplierName: 'සැපයුම්කරුගේ නම',
  contactPerson: 'සම්බන්ධය ගන්නා පුද්ගලයා',
  email: 'ඊමේල්',
  phone: 'දුරකථන අංකය',
  address: 'ලිපිනය',
  city: 'නගරය',
  country: 'රට',
  taxId: 'බදු හැඳුනුම් අංකය / NTN',
  paymentTerms: 'ගෙවීම් කොන්දේසි',
  creditLimit: 'ණය සීමාව',
  notes: 'සටහන්',

  // Placeholders
  enterSupplierName: 'සැපයුම්කරුගේ සමාගම් නම ඇතුළත් කරන්න',
  enterContactPerson: 'සම්බන්ධය ගන්නා පුද්ගලයාගේ නම ඇතුළත් කරන්න',
  enterEmail: 'ඊමේල් ලිපිනය ඇතුළත් කරන්න',
  enterPhone: 'දුරකථන අංකය ඇතුළත් කරන්න',
  enterAddress: 'භෞතික ලිපිනය ඇතුළත් කරන්න',
  enterCity: 'නගරය ඇතුළත් කරන්න',
  enterCountry: 'රට ඇතුළත් කරන්න',
  enterTaxId: 'බදු හැඳුනුම් අංකය ඇතුළත් කරන්න',
  enterPaymentTerms: 'උදා: Net 30, COD',
  enterCreditLimit: 'ණය සීමාව ඇතුළත් කරන්න',
  enterNotes: 'සැපයුම්කරු පිළිබඳ අමතර සටහන්...',

  // Search and filters
  searchSuppliers: 'නම, සම්බන්ධතා, ඊමේල් හෝ දුරකථන අනුව සෙවීම...',
  allStatuses: 'සියලු තත්ත්වයන්',
  filterByCity: 'නගරය අනුව පෙරන්න',
  filterByCountry: 'රට අනුව පෙරන්න',

  // Messages
  supplierCreatedSuccessfully: 'සැපයුම්කරු සාර්ථකව නිර්මාණය කරන ලදි',
  supplierUpdatedSuccessfully: 'සැපයුම්කරු සාර්ථකව යාවත්කාලීන කරන ලදි',
  supplierDeletedSuccessfully: 'සැපයුම්කරු සාර්ථකව මකා ඇත',
  supplierMarkedAsInactive: 'සැපයුම්කරු අක්‍රීය ලෙස සලකන ලදි',
  failedToLoadSuppliers: 'සැපයුම්කරුවන් පූරණය අසාර්ථක විය',
  failedToCreateSupplier: 'සැපයුම්කරු සෑදීම අසාර්ථක විය',
  failedToUpdateSupplier: 'සැපයුම්කරු යාවත්කාලීන කිරීම අසාර්ථක විය',
  failedToDeleteSupplier: 'සැපයුම්කරු මකා දැමීම අසාර්ථක විය',

  // Empty states
  noSuppliersYet: 'සැපයුම්කරුවන් නොපැවතියි',
  noSuppliersYetDescription: 'ඔබගේ පළමු සැපයුම්කරු නිර්මාණය කර ආරම්භ කරන්න.',
  noSuppliersFound: 'සැපයුම්කරුවන් හමු නොවුණි',
  noSuppliersFoundDescription: 'ඔබගේ සෙවීමේ විචල්‍යයන්ට ගැලපෙන සැපයුම්කරුවන් නොමැත. පෙරහන් වෙනස් කර බලන්න.',

  // Delete confirmation
  confirmDelete: '"{{name}}" මකීමට ඔබට අවශ්‍යද?',
  deleteWarning: 'මෙම සැපයුම්කරුට ගන්නාපිටු ඇණවුම් ඇත්නම්, එය ස්ථිරවම මකා දැමීම වෙනුවට අක්‍රීය ලෙස සලකනු ලැබේ.',

  // Validation
  validation: {
    nameRequired: 'සැපයුම්කරුගේ නම අවශ්‍යයි',
    invalidEmail: 'ඊමේල් ආකෘතිය වැරදියි',
    invalidCreditLimit: 'ණය සීමාව වලංගු ධනාත්මක අංකයක් විය යුතුය',
    fixErrors: 'කරුණාකර පෝරමයේ දෝෂ නිවැරදි කරන්න',
  },
  activeHint: "නව මිලදී ගැනුම් ඇණවුම් සඳහා සැපයුම්කරු තෝරාගත හැක",
  inactiveHint: "නව මිලදී ගැනුම් ඇණවුම් වලින් සැපයුම්කරු සඟවා ඇත",
};
